import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ESIInclude from '@JohnLewisPartnership/jl-esi-components';
import styles from './FlyoutMenu.scss';
import FlyoutMenuItem from '../flyout-menu-item/FlyoutMenuItem';

const FlyoutMenu = ({ id, columns, hierarchy, onClose }) => {
  const filteredColumns =
    columns
      ?.filter(column => column.isDisplayedInGlobalNav !== false)
      ?.map(column => ({
        ...column,
        child: column.child?.filter(
          item => item.isDisplayedInGlobalNav !== false
        ),
      }))
      ?.filter(x => x.child?.length || x.images?.length) || [];

  const close = () => {
    if (onClose) onClose();
  };

  return (
    <div className={styles.flyoutMenu} data-testid="desktop-flyout-menu">
      <div className={styles.flyoutMenuColumns}>
        {filteredColumns.map(column => (
          <div
            key={column.name}
            className={classNames(styles.flyoutMenu__column, {
              [styles.twoCol]: column.child?.length > 11,
            })}
          >
            <h4 className={styles.flyoutMenuTitle}>{column.name}</h4>
            {column.child && (
              <ul>
                {column.child.map(link => {
                  const { name, url } = link;
                  return (
                    <FlyoutMenuItem
                      key={name}
                      label={name}
                      url={url}
                      hierarchy={`${hierarchy}|${column.name}`}
                    />
                  );
                })}
              </ul>
            )}
            {column.images?.map(({ src, alt, name, text }) => (
              <div key={name}>
                <img src={src} alt={alt} />
                <span className={styles.imageBlockTitle}>{name}</span>
                <p className={styles.imageBlockText}>{text}</p>
              </div>
            ))}
          </div>
        ))}
      </div>
      <div className={styles.flyoutMenuBanner} data-testid="navigation-content">
        <ESIInclude
          src={`/content-renderer/navigation/${id}?no-hydration=true&no-failure=true&includePolyfills=false&includeCoreJS=false`}
          id="navigation-content"
        />
      </div>
      {onClose && (
        <button className={classNames(styles.close)} onClick={close}>
          <span>Back</span>
        </button>
      )}
    </div>
  );
};

const itemShape = {
  name: PropTypes.string.isRequired,
  url: PropTypes.string,
};
itemShape.child = PropTypes.arrayOf(PropTypes.shape(itemShape));

FlyoutMenu.propTypes = {
  id: PropTypes.string.isRequired,
  columns: PropTypes.arrayOf(PropTypes.shape(itemShape)).isRequired,
  hierarchy: PropTypes.string.isRequired,
};

export default FlyoutMenu;
